<div class="container mt-5">
  <div class="row ">
    <div class="col-md-8 mx-auto">
      <div class="card-group">
        <div class="card text-white bg-primary py-5 d-md-down-none" style="width:44%">
          <div class="card-body text-center">
            <div>
              <h2>Welcome to IE Pay Dashboard</h2>
              <p>Wide range of mobile billing solutions including MO, MT, WAP Billing and Direct Carrier Billing (DCB).API Integration and full reporting system to monitor performance and conversion.</p>
            </div>
          </div>
        </div>
        <div class="card p-4">
          <div class="card-body">
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
              <h1>Logon</h1>
              <p class="text-muted">Sign In to your account</p>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-user"></i></span>
                </div>
                <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" placeholder="Username" />
                <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                  <div *ngIf="f.username.errors.required">Username is required</div>
                </div>
              </div>
              <div class="input-group mb-4">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-lock"></i></span>
                </div>
                <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" placeholder="Password" />
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                  <div *ngIf="f.password.errors.required">Password is required</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button [disabled]="loading" class="btn btn-primary form-control">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Log on
                  </button>
                  <div *ngIf="error" class="alert alert-danger mt-3 mb-0">Username or Password is incorrect.</div>
                </div>
                <!-- <div class="col-6 text-right">
                  <button type="button" class="btn btn-link px-0">Forgot password?</button>
                </div> -->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<footer class="page-footer mt-3 fixed-bottom">
  <p class="text-center footer-copyright"><i class="fa fa-copyright" aria-hidden="true"></i> 2020 Copyright: <span class="text-uppercase">Intelligent Earnings</span></p>
  <p class="text-center">
    <span class="text-info font-weight-bold font-italic">Life is short, I use IE Pay.</span>
    <br>
  </p>
</footer>
